export const appendModalToDom = (className, options = {}) => {
  let configuratorModalEl = document.querySelector(`.${className}`);

  if (!configuratorModalEl) {
    configuratorModalEl = document.createElement('div');
    document.body.appendChild(configuratorModalEl);
    configuratorModalEl.classList.add(className);
    configuratorModalEl.style.display = 'none';
    configuratorModalEl.style.zIndex = options.zIndex || 10000;
    configuratorModalEl.style.position = 'fixed';
    configuratorModalEl.style.top = 0;
    configuratorModalEl.style.left = 0;
    configuratorModalEl.style.height = '100%';
    configuratorModalEl.style.width = '100%';
  }

  return configuratorModalEl;
};
